<template>
  <div
    class="rs-sidebar-card rs-sidebar-card-property"
    @click="() => isUpdatePermitted && $emit('click')"
  >
    <div class="rs-sidebar-card__info">
      <div class="rs-sidebar-card__image">
        <img
          :src="src || '/img/default_300x300.png'"
          :alt="alt || ''"
        >
        <div class="status-wrap">
          <div
            class="status"
            :class="
              'status--'
                + showAvailabilityStatus(
                  status ?? '',
                  availabilityStatus ?? 0,
                ).classname.replaceAll(' ', '-')
            "
          >
            {{ showAvailabilityStatus(status ?? '', availabilityStatus ?? 0).status }}
          </div>
        </div>
      </div>
      <div class="rs-sidebar-card__content truncate w-100">
        <div class="row m-0 flex-nowrap">
          <div class="flex-grow-1 text-truncate">
            <div
              v-show="unitNumber"
              class="font-weight-bold text-muted"
              style="line-height:1"
            >
              #{{ unitNumber }}
            </div>
            <p
              v-show="title"
              class="text-truncate mb-0"
            >
              <b>
                {{ title }}
              </b>
            </p>
            <div class="rate">
              ${{ showRange(rentMin, rentMax) }} / month
            </div>
            <div
              v-show="sizeMin || sizeMax"
              class="meta-shelf"
            >
              <i
                class="fa-fw fa-draw-square fal"
                :data-fa-transform="''"
              />
              <span>{{ sizeMin + ' sqft' }}</span>
            </div>
          </div>

          <div
            class="flex-grow-0 pt-2 p-3"
            :title="`${(status === 'enabled' ? 'Published' : 'Not Published')}`"
          >
            <div :class="`dot bg-${(status === 'enabled' ? 'success' : 'danger')}`" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { convertDateFormatNoYear } from '@/shared';

export default defineComponent({
  name: 'RsSidebarCardProperty',

  props: {
    title: String,
    type: String,
    rent: String,
    status: String,
    unitNumber: {
      type: [String, Number],
      default: '',
    },
    bed: {
      type: [String, Number],
      default: '0',
    },
    bath: {
      type: [String, Number],
      default: '0',
    },
    sizeMin: {
      type: [String, Number],
      default: '0',
    },
    sizeMax: {
      type: [String, Number],
      default: '0',
    },
    rentMin: {
      type: [String, Number],
      default: '0',
    },
    rentMax: {
      type: [String, Number],
      default: '0',
    },
    availabilityStatus: Number,
    availabilityDate: [String, Date],
    numUnits: {
      type: [String, Number],
      default: '0',
    },
    src: String,
    alt: String,
  },
  methods: {
    showRange(minValue: any, maxValue: any) {
      if (minValue === maxValue) {
        return minValue;
      }
      return `${minValue} - $${maxValue}`;
    },
    showAvailabilityStatus(
      recordStatus: string,
      availabilityStatus: number,
    ) {
      const availabilityDate = new Date(this.availabilityDate ?? 0);

      switch (availabilityStatus) {
        case 1:
          if (availabilityDate && availabilityDate > new Date()) {
            return {
              classname: 'available',
              status: convertDateFormatNoYear(availabilityDate.toJSON()),
            };
          }
          return {
            classname: 'available',
            status: 'available',
          };
        case -1:
          return {
            classname: 'waiting list',
            status: 'waiting list',
          };
        default:
          return {
            classname: 'unavailable',
            status: 'unavailable',
          };
      }
    },
  },
});
</script>

<style lang="scss">
@import "@/styles/_variables.scss";
.rs-sidebar-card {
  padding: 1rem 1rem;
  cursor: pointer;
  transition: opacity 0.2s ease;
  border-bottom: 1px solid $extra-light-gray;
  &:hover {
    opacity: 0.8;
  }
  .rs-icon{
    color: $tertiary-muted;
    .icon-text{
      color: black
    }
  }

  .dot {
    width: 8px;
    height: 8px;
    border-radius: 4px;
  }

  &__image {
    position: relative;
    margin-right: 1rem;
    min-height: 75px;
    min-width: 90px;
    border-radius: $global-radius;
    overflow: hidden;
    border: 1px solid $extra-light-gray;
    img {
      width: 88px;
      height: 100%;
      object-fit: cover;
    }
    .status-wrap {
      position: absolute;
      bottom: 0;
      text-align: center;
      padding: 6px;
      width: 100%;
      .status {
        padding: 3px;
        border-radius: 3px;
        font-size: 0.775rem;
        color: $white;
        background: rgba($success, 0.9);
        text-transform: capitalize;

        &--unavailable {
          background: rgba($error, 0.9);
        }
        &--waiting-list {
          background: rgba($tertiary-muted, 0.9);
        }
        &--disabled {
          background: rgba($error, 0.9);
        }
      }
    }
  }
  &__info {
    display: flex;
    align-items: stretch;
    // align-content: center;
  }
  &__content {
    .rs-prop-title {
      margin-bottom: 0;
    }
    .rs-prop-icon {
      margin-right: 1rem;
      &:last-of-type {
        margin-right: 0;
      }
    }
    .meta-shelf {
      margin-top: 0.25rem;
    }
    .rate {
      display: block;
      line-height: 1.2rem;
      font-size: 0.875rem;
      color: $tertiary-muted;
      font-weight: 600;
    }
  }
}
</style>
